var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundPageBgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 800,
    viewBox: "0 0 770 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_48_274)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.634,
    cy: 382.646,
    rx: 514.116,
    ry: 418.922,
    transform: "rotate(43.3795 545.634 382.646)",
    fill: "url(#paint0_linear_48_274)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_48_274",
    x: 0,
    y: -157.618,
    width: 1091.27,
    height: 1080.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_48_274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_274",
    x1: 1059.75,
    y1: 382.646,
    x2: 31.5185,
    y2: 382.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831862,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPageBgRight);
export default __webpack_public_path__ + "static/media/not-found-page-bg-right.bca6165f75ef3302112b7a6bed166f93.svg";
export { ForwardRef as ReactComponent };